export default __webpack_public_path__ + "static/media/tyler_wall.d0b9a17b.jpg";